import api from "~/api";

const useAuthCheck = async (): Promise<boolean> => {
    if (import.meta.server) return true
    try {
        await api.Auth.getCSRFToken()
        await api.User.getUserInfo()
        return true;
    } catch (error) {
        return false;
    }
}

export {useAuthCheck}